<template>
  <div class="d-flex flex-column justify-start px-6">
    <p class="h6 mt-6">
      {{ $t('ai_features.token_deposit_history.title') }}
    </p>
    <div class="d-flex justify-start align-center">
      <v-card outlined class="mt-4 mb-6" width="800px">
        <TokenDepositHistoryTable />
      </v-card>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.vue'

import TokenDepositHistoryTable from '@/components/AIManagement/TokenDepositsHistoryTable.vue'

export default {
  name: 'DepositHistoryTab',

  mixins: [mixin],

  components: {
    TokenDepositHistoryTable,
  },
}
</script>
